import axios from "axios";

export const getEmployee = async (employeeId) => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
  const apiUrl = `http://${url}:4000/api/v1/boletaDigital/getEmployee?id=${employeeId}`;
  //const apiUrl = `http://localhost:4000/api/v1/boletaDigital/getEmployee?id=${employeeId}`;
  const config = {
    method: "GET",
    url: apiUrl,
    headers: {
      "Content-Type": "application/json",
    },
  };
  

  try {
    const response = await axios(config);
    debugger
    return response.data;
  } catch (error) {
    const { response } = error;
    return response;
  }
};
